module.exports = __webpack_public_path__ + "assets/GoldRho2x.5ec986c3042186793f9c66d01b4fca43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldRho2x.png
// module id = 821
// module chunks = 0